import { TenantBookingCancellationReasons } from './types/BookingCancellation';
import { MakeCall } from './createMakeCall';

export interface Payload {
  message: string;
  attachments: string[];
  cancellationReasons: TenantBookingCancellationReasons;
}

const cancelBooking =
  (makeCall: MakeCall) => (conversationId: number, data: Payload) =>
    makeCall('POST', `/api/v2/conversation/${conversationId}/booking-cancel`, {
      data,
    });

export { cancelBooking };
